/* ============================================================
   TRADIE — Move the size selector up next to the colour swatches
   Block order in the section renders colours (<product-variant-
   picker>) well before the size buttons (<pf-size-selector>), with
   the price header, bundle selector and a size-chart link in
   between. Reordering via templates/product.json's block_order is
   risky to hand-edit (huge generated file, easy to corrupt), so
   this repositions the already-rendered elements instead — same
   approach used for price-title-layout.js and mobile-header-reorder.js
   elsewhere in this theme.

   Moves <pf-size-selector> directly after <product-variant-picker>
   (the colour swatches), and brings the "Size chart" link along
   with it, on the same row: a "Size: X" label on the left (like
   the True Classic reference), the chart link on the right.

   The "Size chart" link (#lavar-size-chart, confirmed via DevTools)
   ships from its app as a `position: fixed` floating tab pinned to
   the edge of the viewport — that's why it renders as a vertical
   strip. Reparenting a fixed-position element in the DOM has NO
   visual effect on its own (fixed positioning is relative to the
   viewport, not its DOM parent), so size-selector-restyle.css also
   strips that fixed/vertical styling back to normal inline flow —
   the DOM move here only controls where it sits once un-fixed, and
   sets it to justify-content: space-between so the injected label
   (inserted as its first child, below) sits on the left while the
   link itself sits on the right.

   Re-runs on any DOM change (via MutationObserver) since switching
   colour variant can re-render parts of the product info column.
   Idempotent — no-ops once already positioned correctly.
   ============================================================ */

var PF_SIZE_NAME_MAP = {
  'xxs': 'Extra Extra Small',
  'xs': 'Extra Small',
  's': 'Small',
  'sm': 'Small',
  'm': 'Medium',
  'md': 'Medium',
  'l': 'Large',
  'lg': 'Large',
  'xl': 'Extra Large',
  '2xl': '2X Large',
  'xxl': '2X Large',
  '3xl': '3X Large',
  'xxxl': '3X Large',
  '4xl': '4X Large'
};

function pfExpandSizeName(raw) {
  var key = (raw || '').trim().toLowerCase();
  return PF_SIZE_NAME_MAP[key] || raw;
}

function pfRepositionSizeSelector() {
  var colorPicker = document.querySelector('product-variant-picker');
  var sizeSelector = document.querySelector('pf-size-selector');
  var chartLink = document.getElementById('lavar-size-chart') || document.querySelector('.size-chart');

  if (!colorPicker || !sizeSelector || !colorPicker.parentNode) return;

  var sizeSelectorInPlace =
    sizeSelector.previousElementSibling === colorPicker ||
    (chartLink &&
      sizeSelector.previousElementSibling === chartLink &&
      chartLink.previousElementSibling === colorPicker);

  var chartInPlace = !chartLink || chartLink.classList.contains('pf-size-chart-link');

  if (!(sizeSelectorInPlace && chartInPlace)) {
    if (chartLink) {
      chartLink.classList.add('pf-size-chart-link');
      colorPicker.parentNode.insertBefore(chartLink, colorPicker.nextSibling);
      colorPicker.parentNode.insertBefore(sizeSelector, chartLink.nextSibling);
    } else {
      colorPicker.parentNode.insertBefore(sizeSelector, colorPicker.nextSibling);
    }
  }

  if (chartLink && !chartLink.querySelector('.pf-size-current-label')) {
    var label = document.createElement('span');
    label.className = 'pf-size-current-label';
    label.innerHTML = 'Size: <strong class="pf-size-current-value"></strong>';
    chartLink.insertBefore(label, chartLink.firstChild);
  }

  pfUpdateSizeLabel();
}

function pfUpdateSizeLabel() {
  var checkedInput = document.querySelector('.pf-size-selector .pf-size-input:checked');
  var valueEl = document.querySelector('.pf-size-current-value');
  if (!valueEl) return;

  var rawSize = checkedInput ? checkedInput.getAttribute('data-size') : '';
  valueEl.textContent = pfExpandSizeName(rawSize);

  var labelEl = document.querySelector('.pf-size-current-label');
  if (labelEl) {
    labelEl.style.visibility = rawSize ? 'visible' : 'hidden';
  }
}

document.addEventListener('DOMContentLoaded', pfRepositionSizeSelector);

document.addEventListener('change', function (e) {
  if (e.target && e.target.classList && e.target.classList.contains('pf-size-input')) {
    pfUpdateSizeLabel();
  }
});

var pfSizeReposScheduled = false;
var pfSizeReposObserver = new MutationObserver(function () {
  if (pfSizeReposScheduled) return;
  pfSizeReposScheduled = true;
  requestAnimationFrame(function () {
    pfSizeReposScheduled = false;
    pfRepositionSizeSelector();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  pfSizeReposObserver.observe(document.body, { childList: true, subtree: true });
});
